import React from "react";
import styles from "./notFound.module.css";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

export default function UnAuthorized() {
  const navigate = useNavigate();

  return (
    <div className={styles.notFoundContainer}>
      <h1>403</h1>
      <div className={styles.notFoundContent}>
        <h2>Not Authorized</h2>
        <p>
          Oops! It seems like the page you are looking for is not accessible to
          you.
        </p>
        <Button label="Go to login" onClick={() => navigate("/auth/login")} />
      </div>
    </div>
  );
}
